// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kuqg","colBig":"styles_colBig__3vavG","colSmall":"styles_colSmall__D2qPG","shopifyNameWrapper":"styles_shopifyNameWrapper__1FS29"};